import { supabase } from './supabase';
import { useUserStore } from '../store/userStore';
import type { FeatureKey } from '../types';

export interface MonthlyStats {
  cvCreated: number;
  interviews: number;
  cvScores: number;
  linkedinScores: number;
}

export const EMPTY_STATS: MonthlyStats = { cvCreated: 0, interviews: 0, cvScores: 0, linkedinScores: 0 };

// feature_key (usage_counters) → clé de stat affichée sur le profil.
const STAT_BY_FEATURE: Record<string, keyof MonthlyStats> = {
  cv_create: 'cvCreated',
  interview_sim: 'interviews',
  cv_score: 'cvScores',
  linkedin_score: 'linkedinScores',
};

const TRACKED: FeatureKey[] = ['cv_create', 'interview_sim', 'cv_score', 'linkedin_score'];

// Période courante au format 'YYYY-MM' (mois local), comme stockée dans usage_counters.period.
export function currentPeriod(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/**
 * Reconstruit les 4 statistiques du mois courant depuis usage_counters (les compteurs de quota).
 * RLS : l'utilisateur ne lit que ses propres compteurs.
 */
export async function getMonthlyStats(period: string = currentPeriod()): Promise<MonthlyStats> {
  const userId = useUserStore.getState().user?.id;
  if (!userId) return { ...EMPTY_STATS };

  const { data, error } = await supabase
    .from('usage_counters')
    .select('feature_key, count')
    .eq('user_id', userId)
    .eq('period', period);
  if (error) throw error;

  const stats: MonthlyStats = { ...EMPTY_STATS };
  for (const row of (data as { feature_key: string; count: number }[] | null) ?? []) {
    const key = STAT_BY_FEATURE[row.feature_key];
    if (key && TRACKED.includes(row.feature_key as FeatureKey)) {
      stats[key] = row.count ?? 0;
    }
  }
  return stats;
}
